const MetadataIcon = ({ ...props }) => (
	<svg
		{...props}
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M1.99609 -0.00378418C0.891525 -0.00378418 -0.00390625 0.891645 -0.00390625 1.99622V18.0037C-0.00390625 19.1083 0.891523 20.0037 1.99609 20.0037H18.0036C19.1082 20.0037 20.0036 19.1083 20.0036 18.0037V1.99622C20.0036 0.891647 19.1082 -0.00378418 18.0036 -0.00378418H1.99609ZM1.99609 1.99622L18.0036 1.99622V3.99788H1.99609V1.99622ZM1.99609 5.99788V18.0037H18.0036V5.99788H1.99609ZM8.05926 9.64641C8.25453 9.84168 8.25453 10.1583 8.05926 10.3535L6.41198 12.0008L8.05926 13.6481C8.25453 13.8433 8.25453 14.1599 8.05926 14.3552L7.35216 15.0623C7.1569 15.2576 6.84031 15.2576 6.64505 15.0623L3.93711 12.3544C3.74185 12.1591 3.74185 11.8425 3.93711 11.6472L6.64505 8.93931C6.84031 8.74405 7.1569 8.74405 7.35216 8.93931L8.05926 9.64641ZM13.3546 8.93931C13.1594 8.74405 12.8428 8.74405 12.6475 8.93931L11.9404 9.64641C11.7451 9.84168 11.7451 10.1583 11.9404 10.3535L13.5877 12.0008L11.9404 13.6481C11.7451 13.8433 11.7451 14.1599 11.9404 14.3552L12.6475 15.0623C12.8428 15.2576 13.1594 15.2576 13.3546 15.0623L16.0626 12.3544C16.2578 12.1591 16.2578 11.8425 16.0626 11.6472L13.3546 8.93931Z"
			fill="currentColor"
		/>
	</svg>
)

export default MetadataIcon
